shadow$provide[268] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Transform3:{enumerable:true, get:function() {
  return Transform3;
}}});
var UThree = require("../../../util/three.js");
var require$_DOT__SLASH_transform_DOT_js = require("./transform.js");
class Transform3 extends require$_DOT__SLASH_transform_DOT_js.Transform {
  static initClass() {
    this.traits = ["node", "vertex", "transform3"];
  }
  make() {
    this.uniforms = {transformMatrix:this._attributes.make(this._types.mat4()),};
    return this.composer = UThree.transformComposer();
  }
  unmake() {
    return delete this.uniforms;
  }
  change(changed, touched, init) {
    if (changed["transform3.pass"]) {
      return this.rebuild();
    }
    if (!touched["transform3"] && !init) {
      return;
    }
    const p = this.props.position;
    const q = this.props.quaternion;
    const r = this.props.rotation;
    const s = this.props.scale;
    const m = this.props.matrix;
    const e = this.props.eulerOrder;
    return this.uniforms.transformMatrix.value = this.composer(p, r, q, s, m, e);
  }
  vertex(shader, pass) {
    if (pass === this.props.pass) {
      shader.pipe("transform3.position", this.uniforms);
    }
    return super.vertex(shader, pass);
  }
}
Transform3.initClass();

};